<template>
  <page heading="Frequently Asked Questions">
    <div class="question-list">
      <h2 class="question-title">Are you planning to add accessories?</h2>
      <p>Yes, I am planning to add accessories to the site. You will be able to add them to your collection and wishlist.</p>
      <h2 class="question-title">Do my wishlist and herd have to be public?</h2>
      <p>No, you can update your wishlist and herd settings to make them private. Your data will still be used in the aggregate values for the site but will not be personally identifiable.</p>
      <h2 class="question-title">I don't like to use the category pages. Are you planning to provide a more customizable search option.</h2>
      <p>Yes, I am planning to add more filters the existing category pages and a filtered search page.</p>
      <h2 class="question-title">Can I sell ponies through MyLittlePonyCollection</h2>
      <p>You may not sell ponies directly through this site. You can create a list of items you are planning to sell and share that with other collectors.</p>
      <h2 class="question-title">What do the collection item statuses mean?</h2>
      <p>You can track your collecting progress by assigning the following statuses to your ponies and accessories.</p>
      <ul>
        <li>
          <b>Not Selling: </b>
          No plans to sell
        </li>
        <li>
          <b>Pending Sale: </b>
          Sold but waiting for payment or shipping.
        </li>
        <li>
          <b>Listed: </b>
          Listed for sale
        </li>
        <li>
          <b>Sold: </b>
          Sold, paid and shipped
        </li>
        <li>
          <b>Pending Purchase: </b>
          Purchased but still making payments or waiting for item to arrive.
        </li>
      </ul>
    </div>
  </page>
</template>

<script>
import Page from '../../layouts/Page/Page';

export default {
  name: 'Faq',
  components: {
    Page
  }
};
</script>

<style>
.question-title {
  font-family: 'Signika', sans-serif;
  font-size: 24px;
  font-weight: 900;
}
</style>
